import React from 'react';
import styled from 'styled-components';
import PillSelectBox from '../PillSelectBox';
import { CustomisationTypeTooltip } from '../TooltipModals';

const Container = styled.div`
  width: 170px; //180px
  display: inline-block;
`;

function VariantTypes(props) {
  return (
    <Container>
      <label htmlFor={props.id}>Type</label>
      <CustomisationTypeTooltip />
      <PillSelectBox
        id={props.id}
        value={props.value}
        onChange={e => props.onChange(e)}
      >
        <option className="select-box__option" value="single">
          Single Choice
        </option>
        <option className="select-box__option" value="multiple">
          Multiple Choice
        </option>
      </PillSelectBox>
    </Container>
  );
}

export default VariantTypes;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/VariantTypes/index.jsx